import type { MarkerColor } from "../../misc/markerColors";
import { colorForKey } from "../../misc/markerColors";

export const NO_ACCOUNT_MANAGER_COLOR: MarkerColor = { color: "#ffffff", backgroundColor: "#9e9e9e" };

export function accountManagerColor(accountManager: { readonly id: string } | undefined): MarkerColor {
  return accountManager ? colorForKey(accountManager.id) : NO_ACCOUNT_MANAGER_COLOR;
}
